// extracted by mini-css-extract-plugin
export default {"wrapper":"gyGlk___Layout-module__wrapper","tabs":"ttKK2___Layout-module__tabs"};